export const VACANCY_DETAILS_TABS = {
  vacancyDetails: 'vacancy-details',
  applicants: 'applicants',
  applicantDetails: 'applicantDetails',
};
